export const GUIDED_JOURNEY_CONFIG = Object.freeze({
  version: 1,
  storagePrefix: "zinihub_guided_journey",
  targetWaitMs: 6000,
  targetPollMs: 120,
  spotlightPadding: 10,
  spotlightRadius: 12,
  tooltipWidth: 320,
});

export const GUIDED_JOURNEY_STAGE = Object.freeze({
  HUB_SETUP: "hub-setup",
  WAITING_FOR_HUB: "waiting-for-hub",
  SUBSCRIPTION: "subscription",
  WAITING_FOR_SUBSCRIPTION: "waiting-for-subscription",
  CREATE_BUSINESS: "create-business",
  WAITING_FOR_BUSINESS: "waiting-for-business",
  FIRST_DRAFT: "first-draft",
  COMPLETE: "complete",
});

export const GUIDED_JOURNEY_TARGET = Object.freeze({
  HUB_DISPLAY_NAME: "guide-hub-display-name",
  HUB_DOMAIN_NAME: "guide-hub-domain-name",
  HUB_DOMAIN_CHECK: "guide-hub-domain-check",
  HUB_DOMAIN_PREVIEW: "guide-hub-domain-preview",
  HUB_SUBMIT: "guide-hub-submit",
  SUBSCRIPTION_ACTIVATION: "guide-subscription-activation",
  SUBSCRIPTION_TRIAL: "guide-subscription-trial",
  SUBSCRIPTION_PAID: "guide-subscription-paid",
  CREATE_BUSINESS: "guide-create-business",
  DRAFT_TAB: "guide-draft-tab",
});

export function getGuidedJourneyBusinessTarget(bizId) {
  return `guide-business-${encodeURIComponent(String(bizId || ""))}`;
}

export function shouldShowFirstDraftResult(result) {
  return Boolean(
    result &&
    result.cancelled !== true &&
    result.firstBusiness === true &&
    result.isDraft === true &&
    result.bizId &&
    result.hubId
  );
}

export function resolveGuidedJourneyStage(accessState, progressStage) {
  if (accessState === "HUB_SETUP_REQUIRED") {
    return GUIDED_JOURNEY_STAGE.HUB_SETUP;
  }
  if (accessState === "ACTIVATION_REQUIRED") {
    return GUIDED_JOURNEY_STAGE.SUBSCRIPTION;
  }
  if (progressStage && progressStage !== GUIDED_JOURNEY_STAGE.COMPLETE) {
    return progressStage;
  }
  return null;
}
